import React , {Component} from 'react'
import {Row,Container} from 'reactstrap'
import Card from '../Cards/Card'
import '../HomePage/index.css'
import { Helmet } from 'react-helmet'
import SpinnerPage from '../Loader/SpinnerPage';
import * as actionCreators from '../../Actions/Index';
import {withRouter} from 'react-router-dom';
import {connect} from "react-redux";
import TopNav from '../NavBar/TopNav'
import Cookies from 'universal-cookie'

const cookies = new Cookies();


class Index extends Component{

constructor(props){

   super(props);
   this.state = {
    productsList: [],
    cat: {},        
    error: [],
    JigarKey:[],
    showItems:20,
    success:false,
    isloder:true,
    JigarProduct:[],
   }
}
isBottom(el) {
  return el.getBoundingClientRect().bottom <= window.innerHeight+200;
}
  componentWillMount(){
  //   var cate ={ 
  //     "ProductCategory":[],
  //     "ProductType":[],  
  //     "Color":[],
  //     "BrandName":[],
  //      "Fabric":[],
  //      "Design":[],
  //      "PageNo": 40,
  //       "Min":0,
  //      "Max":500000,
  //      "UserID":cookie.get("usfid")
  // };
    

  //   console.log("catcat   "+this.state.cat.Color)


   document.addEventListener('scroll', this.trackScrolling);

  //   this.unlisten = this.props.history.listen((location, action) => {
  //       this.props.getUserOrders(this.state.cat);
  //   this.setState({productsList:this.props.productsList});
  //   });
  //   this.props.getUserOrders(cate);
  //   console.log(this.props.productsList);
  //   this.setState({productsList:this.props.productsList});
  //   if(this.props.loginStatus){
  //     this.setState({success:true})
  //   }

  //this.props.getJigarKey();

  let cookJigarKey = cookies.get("jigarKey");

  if(cookJigarKey == null || cookJigarKey != this.props.JigarKey[0]){
   
  let d = new Date();
  d.setTime(d.getTime() + (6000 * 6000 * 24000));
  if(this.props.JigarKey)
  cookies.set('jigarKey', this.props.JigarKey[0], { path: '/', expires: d });

  this.props.getProductFromMorphJigar();
  
}
  else{
    var array= this.props.JigarProduct;
    var currentIndex = array?.length, temporaryValue, randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
  
      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }
  }
 


  // axios.get(morph_api_url , {
  //   params: {
  //     key: '7hDDGSosf23K7474Bd4P',
  //     query: "Select product.ProductID ,product.Price, product.Brand_Name ,images.ImageURL from product,images where product.SKU = Images.SKU and images.display = 1 order by RANDOM()"  
  //   }
  // })
  //   .then(response => {
  //       console.log(response);
  //   }).catch({ status: 500, message: 'Internal Server Error' });
  
  
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.trackScrolling);
  }

  componentWillReceiveProps(nextProps){
    this.setState({productsList:nextProps.productsList});
}
trackScrolling = () => {
  const wrappedElement = document.getElementById('root');
  if (this.isBottom(wrappedElement)) {
    
    this.handleShowMore();
  }
};
handleShowMore() {
  this.setState({
    showItems: 
      this.state.showItems >= this.props.JigarProduct?.length ?
        this.state.showItems : this.state.showItems + 20
  })
}

render(){
        
    return ( <div>
     <TopNav heading="Selectfashion"/> 
             {/* <BrowserView>
            <SideBar expanded={true} />
            </BrowserView> */}
         
            <Helmet>
    <meta name="description" content="Shop the latest women's clothing and fashion online at SelectFashion and discover more 10000s of on-trend styles at affordable prices. New lines added daily. Free delivery!" />
   
            <title>Women's Clothing | Online Shopping | Fashion Clothes Pakistan | SELECTFASHION</title>
    </Helmet>
            <Container className="productContainer">
            {this.state.isloder?
            <div style={{marginLeft:"44%" , marginTop:"32%"}}>
            <SpinnerPage /></div> :null}
              <Row>
               {/* {this.props.location.state?
              <LoginSuc />:null} */}
                <ol className="product-items">
                {this.props.JigarProduct != null ?
                  <div>
                 {this.props.JigarProduct.slice(0,this.state.showItems).map(item=>{
                   if(this.state.isloder)
                   this.setState({isloder:false})
                    return(
                 <Card key={item._id} ProductURL={item.URL} SKU={item.SKU} currencyRS="Rs" header={item.Title} id={item._id} title={item.Brand_Name} image={item.mImage} price={item.price} saveCount={item.ProductCount}></Card>    
               
                 )}
                    )} 
                    </div>:null}
                </ol> 
                </Row>
            </Container>
            </div>
        )
                    }
}
const mapStateToProps=(state)=>(

  {
    JigarProduct:state.JigarProduct,
    JigarKey:state.JigarKey,
});

const mapDispatchToProps = dispatch => {
  
  return {
    
    getJigarKey:()=>dispatch(actionCreators.getJigarKey()),
    getProductFromMorphJigar: () => dispatch(actionCreators.getProductFromMorphJigar()),
  }
  
}
export default  withRouter(connect(mapStateToProps,mapDispatchToProps)(Index))
